import React, { useState, useEffect, useCallback } from 'react';
import {
  faCircleCheck,
  faCircleXmark,
  faEye,
  faRotate,
} from '@fortawesome/free-solid-svg-icons';
import { withAppHOC } from '../../../hoc';
import PageHeading from '../../../components/PageHeader/PageHeader';
import LoadingSpinner from '../../../components/LoadingSpinner/LoadingSpinner';
import NoData from '../../../components/NoData/NoData';
import StatusHighliter from '../../../components/StatusHighliter/StatusHighliter';
import {
  FormContainer,
  Form,
  Fieldset,
  Label,
  TextInput,
  CreateButton,
  MessageBox,
  CustomButton,
  ResetButton,
  Button,
  Dropdown,
  CustomConfirmButton,
} from '../../../components/FormElements';
import { TableBuilder } from '../../../components/TableElements';
import {
  StyledIconTitleContainer,
  StyledIconContainer,
  StyledTitleContainer,
  StyledSpan,
  StyledModalContainer,
  StyledFiltersContainer,
  StyledRechargeCountsContainer,
  StyledRechargeCounter,
  StyledHeader,
  StyledApiCallLogsContainer,
  StyledBodyContainer,
  StyledHeading,
  StyledContent,
} from '../../../components/Styled';
import { Image } from '../../../components/Image';
import Modal from '../../../components/Modal';
import OverlayLoader from '../../../components/OverlayLoader/OverlayLoader';
import Pagination from '../../../components/Pagination/Pagination';
import API from '../../../api';
import {
  ACCOUNT_TYPES,
  API_RESPONSE_TYPES,
  PERMISSION_TYPES,
} from '../../../constants';
import {
  getSearchParams,
  camelCaseToString,
  authData,
  formatCurrency,
  shouldRedirect,
  redirectToPageOne,
} from '../../../utils';
import FiltersButton from '../../../components/FiltersButton/FiltersButton';
import { isEmpty } from 'lodash';
import moment from 'moment';
import Accordination from '../../../components/Accordination/Accordination';
import { Grid, GridItem } from '../../../components/Grid';
import JSONPretty from 'react-json-pretty';
import Textinput from '../../../components/FormElements/TextInput';

const FundRequestsTable = (props) => {
  const { accountType } = authData.get();
  const [paginationData, setPaginationData] = useState({
    pageNumber: getSearchParams('pageNumber') || 1,
    recordsPerPage: getSearchParams('recordsPerPage') || 10,
  });
  const [totalRecords, setTotalRecords] = useState(0);
  const [isFiltering, setIsFiltering] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [responseStatus, setResponseStatus] = useState('');
  const [responseMessage, setResponseMessage] = useState('');
  const [walletDepositRequests, setWalletDepositRequests] = useState([]);
  const [counts, setCounts] = useState({});
  const [accounts, setAccounts] = useState([]);
  const [status, setStatus] = useState('All');
  const [rolesId, setRolesId] = useState('');
  const [accountsId, setAccountsId] = useState('');
  const [startDate, setStartDate] = useState(moment().format('YYYY-MM-DD'));
  const [endDate, setEndDate] = useState(moment().format('YYYY-MM-DD'));
  const [showModal, setShowModal] = useState(false);
  const [modalType, setModalType] = useState('');
  const [walletDepositRequestsId, setWalletDepositRequestsId] = useState('');
  const [remark, setRemark] = useState('');
  const [upiTransactionId, setUpiTransactionId] = useState('');
  const [depositType, setDepositType] = useState('');
  const [pgList, setPGList] = useState([]);
  const [pgId, setPGId] = useState('');
  const [logs, setLogs] = useState([]);
  const [utrNumber, setUtrNumber] = useState('');

  const resetResponseData = () => {
    setIsLoading(false);
    setResponseStatus('');
    setResponseMessage('');
  };

  const resetForm = () => {
    setRemark('');
  };

  const readCounts = useCallback(
    (
      depositType = '',
      status = '',
      accountsId = '',
      startDate = '',
      endDate = '',
      upiTransactionId = '',
      pgId = ''
    ) => {
      setIsLoading(true);
      setResponseStatus('');
      setResponseMessage('');
      API.get(
        `/accounting/wallet-deposit-new/fund-requests-counts?pageNumber=${paginationData.pageNumber}&recordsPerPage=${paginationData.recordsPerPage}&fPgid=${pgId}&fUpiTransactionId=${upiTransactionId}&fDepositType=${depositType}&fStatus=${status}&fAccountsId=${accountsId}&fStartDate=${startDate}&fEndDate=${endDate}`
      )
        .then((response) => {
          const { status, data } = response.data;
          if (status === API_RESPONSE_TYPES.SUCCESS) {
            setCounts(data[0]);
          }
        })
        .catch((error) => {
          setResponseStatus(API_RESPONSE_TYPES.FAILURE);
          setResponseMessage(error.message);
        })
        .finally(() => {
          setIsLoading(false);
        });
    },
    []
  );

  const clearFilters = () => {
    setDepositType('');
    setStatus('All');
    setRolesId('');
    setAccountsId('');
    setStartDate(moment().format('YYYY-MM-DD'));
    setEndDate(moment().format('YYYY-MM-DD'));
    setUpiTransactionId('');
    setPGId('');
  };

  const resetFilters = () => {
    clearFilters();
    readData(
      depositType,
      status,
      accountsId,
      startDate,
      endDate,
      upiTransactionId,
      pgId
    );
    readCounts(
      depositType,
      status,
      accountsId,
      startDate,
      endDate,
      upiTransactionId,
      pgId
    );
  };

  const readAccounts = () => {
    API.get('/accounts-management/accounts').then((response) => {
      const { status, data } = response.data;
      if (status === API_RESPONSE_TYPES.SUCCESS) {
        setAccounts(data);
      }
    });
  };

  const readPaymentGateways = () => {
    API.get('/configurations/payment-gateway-configuration').then(
      (response) => {
        const { status, data } = response.data;
        if (status === API_RESPONSE_TYPES.SUCCESS) {
          setPGList(data);
        }
      }
    );
  };

  const readData = useCallback(
    (
      depositType = '',
      status = '',
      accountsId = '',
      startDate = '',
      endDate = '',
      upiTransactionId = '',
      pgId = ''
    ) => {
      setIsLoading(true);
      setResponseStatus('');
      setResponseMessage('');
      API.get(
        `/accounting/wallet-deposit-new/fund-requests?pageNumber=${paginationData.pageNumber}&recordsPerPage=${paginationData.recordsPerPage}&fPgid=${pgId}&fUpiTransactionId=${upiTransactionId}&fDepositType=${depositType}&fStatus=${status}&fAccountsId=${accountsId}&fStartDate=${startDate}&fEndDate=${endDate}`
      )
        .then((response) => {
          const { status, data, pageInfo } = response.data;
          if (shouldRedirect(data?.length, paginationData?.pageNumber)) {
            redirectToPageOne();
          } else {
            if (status === API_RESPONSE_TYPES.SUCCESS) {
              setTotalRecords(pageInfo.totalRecords);
            }
            setWalletDepositRequests(data);
          }
        })
        .catch((error) => {
          setResponseStatus(API_RESPONSE_TYPES.FAILURE);
          setResponseMessage(error.message);
        })
        .finally(() => {
          setIsLoading(false);
        });
    },
    [paginationData]
  );

  const onSubmit = (e) => {
    const walletDepositRequest = walletDepositRequests.find(
      (item) => item.id === walletDepositRequestsId
    );
    e.preventDefault();
    setIsLoading(true);
    setResponseStatus('');
    setResponseMessage('');
    let formData = {};
    if (modalType === 'Approve') {
      formData = {
        ...walletDepositRequest,
        approvalStatus: 'Approved',
        remark,
      };
    } else {
      formData = {
        ...walletDepositRequest,
        approvalStatus: 'Rejected',
        remark,
      };
    }
    API.put(
      `/accounting/wallet-deposit-requests/${walletDepositRequestsId}?pageNumber=${paginationData.pageNumber}&recordsPerPage=${paginationData.recordsPerPage}&fStatus=${status}&fAccountsId=${accountsId}&fStartDate=${startDate}&fEndDate=${endDate}`,
      formData
    )
      .then((response) => {
        const { status, message } = response.data;
        setResponseStatus(status);
        setResponseMessage(message);
        if (status === API_RESPONSE_TYPES.SUCCESS) {
          resetForm();
          reloadData();
          setTimeout(() => {
            resetResponseData();
            setWalletDepositRequestsId('');
            setModalType('');
            setShowModal(false);
          }, 3000);
        }
      })
      .catch((error) => {
        setResponseStatus(API_RESPONSE_TYPES.FAILURE);
        setResponseMessage(error.message);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const reloadTransaction = (id) => {
    setIsLoading(true);
    setResponseStatus('');
    setResponseMessage('');
    API.get(`/accounting/payment-gateway-deposits/status-check/${id}`)
      .then((response) => {
        const { message } = response.data;
        if (response.data.status === API_RESPONSE_TYPES.SUCCESS) {
          reloadData();
        } else {
          setResponseStatus(response.data.status);
          setResponseMessage(message);
        }
      })
      .catch((error) => {
        setResponseStatus(API_RESPONSE_TYPES.FAILURE);
        setResponseMessage(error.message);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const updateTransaction = (id, approvalStatus) => {
    if (approvalStatus === 'Approved' && (!utrNumber || isEmpty(utrNumber))) {
      setResponseStatus(API_RESPONSE_TYPES.FAILURE);
      setResponseMessage('Please enter utr number');
    } else {
      setIsLoading(true);
      setResponseStatus('');
      setResponseMessage('');
      const formData = {
        approvalStatus,
        remark: approvalStatus,
        utrNumber,
      };
      API.put(`/accounting/payment-gateway-deposits/${id}`, formData)
        .then((response) => {
          const { status, message } = response.data;
          if (status === API_RESPONSE_TYPES.FAILURE) {
            setResponseStatus(status);
            setResponseMessage(message);
          } else {
            reloadData();
          }
        })
        .catch((error) => {
          setResponseStatus(API_RESPONSE_TYPES.FAILURE);
          setResponseMessage(error.message);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  };

  const reloadData = () => {
    readData(
      depositType,
      status,
      accountsId,
      startDate,
      endDate,
      upiTransactionId,
      pgId
    );
    readCounts(
      depositType,
      status,
      accountsId,
      startDate,
      endDate,
      upiTransactionId,
      pgId
    );
  };

  const filterData = (e) => {
    e.preventDefault();
    setIsFiltering(true);
  };

  const onClickExport = () => {
    setIsLoading(true);
    setResponseStatus('');
    setResponseMessage('');
    API.get(
      `/accounting/wallet-deposit-new/fund-requests-export?fPgid=${pgId}&fUpiTransactionId=${upiTransactionId}&fDepositType=${depositType}&fStatus=${status}&fAccountsId=${accountsId}&fStartDate=${startDate}&fEndDate=${endDate}`
    )
      .then((response) => {
        const { status, message } = response.data;
        if (status === API_RESPONSE_TYPES.FAILURE) {
          setResponseStatus(status);
          setResponseMessage(message);
        } else {
          setResponseStatus(status);
          setResponseMessage(message);
          setTimeout(() => {
            setResponseStatus('');
            setResponseMessage('');
          }, 3000);
        }
      })
      .catch((error) => {
        setResponseStatus(API_RESPONSE_TYPES.FAILURE);
        setResponseMessage(error.message);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    if (isFiltering) {
      setPaginationData((paginationData) => ({
        pageNumber: 1,
        recordsPerPage: paginationData.recordsPerPage,
      }));
      setIsFiltering((isFiltering) => !isFiltering);
    }
  }, [isFiltering]);

  useEffect(() => {
    readAccounts();
    if (
      ![
        ACCOUNT_TYPES.MASTER_DISTRIBUTORS,
        ACCOUNT_TYPES.DISTRIBUTORS,
        ACCOUNT_TYPES.RETAILERS,
        ACCOUNT_TYPES.API_USERS,
      ].includes(accountType)
    ) {
      readPaymentGateways();
    }
  }, []);

  useEffect(() => {
    if (!isFiltering) {
      readData(
        depositType,
        status,
        accountsId,
        startDate,
        endDate,
        upiTransactionId,
        pgId
      );
      readCounts(
        depositType,
        status,
        accountsId,
        startDate,
        endDate,
        upiTransactionId,
        pgId
      );
    }
  }, [paginationData, readData, readCounts]);

  useEffect(() => {
    readData(
      depositType,
      status,
      accountsId,
      startDate,
      endDate,
      upiTransactionId,
      pgId
    );
    readCounts(
      depositType,
      status,
      accountsId,
      startDate,
      endDate,
      upiTransactionId,
      pgId
    );
  }, []);

  const { accountsPermissions } = props;
  const canUpdate =
    accountsPermissions.includes(PERMISSION_TYPES.UPDATE) || false;
  const canExport =
    accountsPermissions.includes(PERMISSION_TYPES.EXPORT) || false;
  const canStatusCheck =
    accountsPermissions.includes(PERMISSION_TYPES.STATUS_CHECK) || false;
  const canTrack =
    accountsPermissions.includes(PERMISSION_TYPES.TRACK) || false;

  const rolesOptions = [{ title: '-- SELECT ROLE --', value: '' }];
  if (accountType === ACCOUNT_TYPES.MASTER_DISTRIBUTORS) {
    [
      {
        id: 3,
        roleName: 'Distributors',
      },
      {
        id: 4,
        roleName: 'Retailers',
      },
    ].forEach(({ id, roleName }) =>
      rolesOptions.push({
        title: roleName,
        value: id,
      })
    );
  } else if (accountType === ACCOUNT_TYPES.DISTRIBUTORS) {
    [
      {
        id: 4,
        roleName: 'Retailers',
      },
    ].forEach(({ id, roleName }) =>
      rolesOptions.push({
        title: roleName,
        value: id,
      })
    );
  } else {
    [
      {
        id: 2,
        roleName: 'Master Distributors',
      },
      {
        id: 3,
        roleName: 'Distributors',
      },
      {
        id: 4,
        roleName: 'Retailers',
      },
      {
        id: 5,
        roleName: 'API Users',
      },
    ].forEach(({ id, roleName }) =>
      rolesOptions.push({
        title: roleName,
        value: id,
      })
    );
  }

  const accountsOptions = [{ title: '-- SELECT ACCOUNT --', value: '' }];
  accounts
    .filter((account) => account?.isDeleted === 'No')
    .filter(({ accountsRolesId }) =>
      rolesId !== ''
        ? accountsRolesId === rolesId
        : [2, 3, 4, 5].includes(accountsRolesId)
    )
    .forEach(({ id, firstName, lastName }) =>
      accountsOptions.push({
        title: `${firstName} ${lastName}`,
        value: id,
      })
    );

  const pgOptions = [{ title: '-- SELECT PAYMENT GATEWAY --', value: '' }];
  if (
    ![
      ACCOUNT_TYPES.MASTER_DISTRIBUTORS,
      ACCOUNT_TYPES.DISTRIBUTORS,
      ACCOUNT_TYPES.RETAILERS,
      ACCOUNT_TYPES.API_USERS,
    ].includes(accountType) &&
    pgList &&
    pgList.length > 0
  ) {
    pgList.forEach(({ id, paymentGatewayName }) =>
      pgOptions.push({
        title: paymentGatewayName,
        value: id,
      })
    );
  }

  const [showFilters, setShowFilters] = useState(false);
  const onClickShowFilters = () => {
    setShowFilters((showFilters) => !showFilters);
  };

  const readApiLogs = (id) => {
    setIsLoading(true);
    setResponseStatus('');
    setResponseMessage('');
    API.get(`/accounting/payment-gateway-deposits/logs/${id}`)
      .then((response) => {
        const { status, data } = response.data;
        if (status === API_RESPONSE_TYPES.SUCCESS) {
          setLogs(data);
        }
      })
      .catch((error) => {
        setResponseStatus(API_RESPONSE_TYPES.FAILURE);
        setResponseMessage(error.message);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const toggleApiLogs = (id) => {
    readApiLogs(id);
    setModalType('Logs');
    setShowModal(true);
  };

  return (
    <>
      <PageHeading
        {...props}
        reloadData={reloadData}
        showExport={canExport}
        onClickExport={onClickExport}
      />
      <FiltersButton onClick={onClickShowFilters} value={showFilters} />
      <StyledFiltersContainer className={showFilters ? 'show' : ''}>
        <Form method="POST" action="#" onSubmit={filterData}>
          {[ACCOUNT_TYPES.ADMINS, ACCOUNT_TYPES.RETAILERS].includes(
            accountType
          ) && (
              <Fieldset>
                <Label>Deposit Type</Label>
                <Dropdown
                  style={{ border: '1px solid #cacaca' }}
                  placeholder="Deposit Type"
                  value={depositType}
                  onChange={setDepositType}
                  options={[
                    {
                      title: '-- SELECT DEPOSIT TYPE --',
                      value: '',
                    },
                    {
                      title: 'Payment Gateway',
                      value: 'Payment Gateway',
                    },
                    {
                      title: 'Fund Requests',
                      value: 'Fund Requests',
                    },
                  ]}
                  disabled={isLoading}
                />
              </Fieldset>
            )}
          {![
            ACCOUNT_TYPES.MASTER_DISTRIBUTORS,
            ACCOUNT_TYPES.DISTRIBUTORS,
            ACCOUNT_TYPES.RETAILERS,
            ACCOUNT_TYPES.API_USERS,
          ].includes(accountType) &&
            depositType !== 'Fund Requests' && (
              <Fieldset>
                <Label>Payment Gateway</Label>
                <Dropdown
                  style={{ border: '1px solid #cacaca' }}
                  placeholder="Payment Gateway"
                  value={pgId}
                  onChange={setPGId}
                  options={pgOptions}
                  disabled={isLoading}
                />
              </Fieldset>
            )}
          <Fieldset>
            <Label>Status</Label>
            <Dropdown
              style={{ border: '1px solid #cacaca' }}
              placeholder="Status"
              value={status}
              onChange={setStatus}
              options={[
                {
                  title: '-- SELECT STATUS --',
                  value: '',
                },
                {
                  title: 'All',
                  value: 'All',
                },
                {
                  title: 'Pending',
                  value: 'Pending',
                },
                {
                  title: 'Approved',
                  value: 'Approved',
                },
                {
                  title: 'Rejected',
                  value: 'Rejected',
                },
              ]}
              disabled={isLoading}
            />
          </Fieldset>
          <Fieldset>
            <Label>Role</Label>
            <Dropdown
              style={{ border: '1px solid #cacaca' }}
              placeholder="Role"
              value={rolesId}
              onChange={(value) => {
                setAccountsId('');
                setRolesId(value);
              }}
              options={rolesOptions}
              disabled={isLoading}
            />
          </Fieldset>
          <Fieldset>
            <Label>Account</Label>
            <Dropdown
              style={{ border: '1px solid #cacaca' }}
              placeholder="Account"
              value={accountsId}
              onChange={setAccountsId}
              options={accountsOptions}
              disabled={isLoading}
            />
          </Fieldset>
          <Fieldset>
            <Label>Start Date</Label>
            <TextInput
              type="date"
              value={startDate}
              onChange={setStartDate}
              placeholder="Start Date"
              disabled={isLoading === true}
            />
          </Fieldset>
          <Fieldset>
            <Label>End Date</Label>
            <TextInput
              type="date"
              value={endDate}
              onChange={setEndDate}
              placeholder="End Date"
              disabled={isLoading === true}
            />
          </Fieldset>
          <Fieldset>
            <Label>UTR Number</Label>
            <TextInput
              value={upiTransactionId}
              onChange={setUpiTransactionId}
              placeholder="UTR Number"
              disabled={isLoading === true}
            />
          </Fieldset>
          <Fieldset>
            <Button disabled={isLoading === true} type="submit">
              Filter
            </Button>
            <ResetButton
              disabled={isLoading === true}
              type="button"
              onClick={resetFilters}
            >
              Clear
            </ResetButton>
          </Fieldset>
        </Form>
      </StyledFiltersContainer>
      <StyledRechargeCountsContainer>
        {counts.successAmount && (
          <StyledRechargeCounter color={'forestgreen'}>
            <StyledHeader>{`${formatCurrency(counts.successAmount)} ( ${counts.successCount
              } )`}</StyledHeader>
          </StyledRechargeCounter>
        )}
        {counts.failureAmount && (
          <StyledRechargeCounter color={'red'}>
            <StyledHeader>{`${formatCurrency(counts.failureAmount)} ( ${counts.failureCount
              } )`}</StyledHeader>
          </StyledRechargeCounter>
        )}
        {counts.pendingAmount && (
          <StyledRechargeCounter color={'#ff9800'}>
            <StyledHeader>{`${formatCurrency(counts.pendingAmount)} ( ${counts.pendingCount
              } )`}</StyledHeader>
          </StyledRechargeCounter>
        )}
      </StyledRechargeCountsContainer>
      {!showModal && responseStatus && responseMessage && (
        <MessageBox status={responseStatus} message={responseMessage} />
      )}
      <LoadingSpinner
        isLoading={
          responseStatus === '' &&
          !showModal &&
          walletDepositRequests?.length === 0 &&
          isLoading
        }
      />
      <NoData
        status={
          responseStatus !== API_RESPONSE_TYPES.FAILURE &&
          !isLoading &&
          walletDepositRequests?.length === 0
        }
        message={`No fund requests found`}
      />
      {walletDepositRequests?.length > 0 && (
        <>
          <TableBuilder
            isLoading={
              !showModal && walletDepositRequests?.length !== 0 && isLoading
            }
            tableHeadings={[
              {
                title: '',
                dataSelector: 'id',
                sticky: true,
                canSort: false,
                width: '100px',
                CellRenderer: (value, item) => (
                  <>
                    {canTrack && (
                      <CustomButton
                        icon={faEye}
                        onClick={() => toggleApiLogs(value)}
                        style={{ color: 'orange' }}
                      />
                    )}
                    {canUpdate && item.approvalStatus === 'Pending' && (
                      <>
                        {item.depositRequestType === 'Payment Gateway' ? (
                          <>
                            {canStatusCheck && (
                              <CustomButton
                                icon={faRotate}
                                onClick={() => reloadTransaction(value)}
                                style={{ color: '#333f7a' }}
                              />
                            )}
                            <CustomConfirmButton
                              icon={faCircleCheck}
                              title="Approve"
                              message="Are you sure, you want to approve this transaction?"
                              proceedButtonText="Approve"
                              cancelButtonText="Cancel"
                              onClick={() =>
                                updateTransaction(value, 'Approved')
                              }
                              color="forestgreen"
                              hoverColor="#006200"
                              reset={() => {
                                setUtrNumber('');
                              }}
                              CustomConponent={() => (
                                <>
                                  <Textinput
                                    value={utrNumber}
                                    onChange={setUtrNumber}
                                    placeholder="Please enter UTR number"
                                    disabled={isLoading}
                                    autoFocus="on"
                                  />
                                  <br></br>
                                </>
                              )}
                            />
                            <CustomConfirmButton
                              icon={faCircleXmark}
                              title="Reject"
                              message="Are you sure, you want to reject this transaction?"
                              proceedButtonText="Reject"
                              cancelButtonText="Cancel"
                              onClick={() =>
                                updateTransaction(value, 'Rejected')
                              }
                            />
                          </>
                        ) : (
                          <>
                            <CustomButton
                              icon={faCircleCheck}
                              onClick={() => {
                                setWalletDepositRequestsId(value);
                                setModalType('Approve');
                                setShowModal(true);
                              }}
                            />
                            <CustomButton
                              icon={faCircleXmark}
                              onClick={() => {
                                setWalletDepositRequestsId(value);
                                setModalType('Reject');
                                setShowModal(true);
                              }}
                              style={{ color: 'red' }}
                            />
                          </>
                        )}
                      </>
                    )}
                  </>
                ),
              },
              {
                title: 'Account Details',
                dataSelector: 'fromAccountsId',
                dataType: 'string',
                CellRenderer: (value, item) => {
                  const {
                    firstName,
                    lastName,
                    isEntity,
                    entityName,
                    roleName,
                    photo,
                    mobileNumber,
                  } = item;
                  return (
                    value && (
                      <StyledIconTitleContainer>
                        <StyledIconContainer>
                          <Image
                            source={
                              photo && !isEmpty(photo) && photo !== 'null'
                                ? photo
                                : '/no-image.png'
                            }
                            alt={
                              isEntity === 'Yes'
                                ? entityName
                                : `${firstName} ${lastName}`
                            }
                            style={{ width: '50px', height: '50px' }}
                          />
                        </StyledIconContainer>
                        <StyledTitleContainer>
                          {isEntity === 'Yes'
                            ? entityName
                            : `${firstName} ${lastName}`}
                          <StyledSpan>{mobileNumber}</StyledSpan>
                          <StyledSpan>{camelCaseToString(roleName)}</StyledSpan>
                        </StyledTitleContainer>
                      </StyledIconTitleContainer>
                    )
                  );
                },
              },
              {
                title: 'Deposit Details',
                dataSelector: 'depositRequestType',
                dataType: 'string',
                CellRenderer: (value, item) => {
                  const { bankName, bankAccountNumberOrUpi } = item;
                  return (
                    <>
                      {value}
                      {bankName && <StyledSpan>{bankName}</StyledSpan>}
                      {bankAccountNumberOrUpi && (
                        <StyledSpan>{bankAccountNumberOrUpi}</StyledSpan>
                      )}
                    </>
                  );
                },
              },
              {
                title: 'Gateway',
                dataSelector: 'paymentGatewayName',
                dataType: 'string',
                requiredRoles: [ACCOUNT_TYPES.ADMINS, ACCOUNT_TYPES.STAFF],
                CellRenderer: (value) => (value ? value : 'N/A'),
              },
              {
                title: 'UTR / Reference Number',
                dataSelector: 'transactionsUTRNumber',
                dataType: 'string',
                CellRenderer: (value) => (value ? value : 'N/A'),
              },
              {
                title: 'Amount',
                dataSelector: 'amount',
                dataType: 'number',
                align: 'center',
                CellRenderer: (value) => formatCurrency(value),
              },
              {
                title: 'Status',
                dataSelector: 'approvalStatus',
                dataType: 'string',
                align: 'center',
                CellRenderer: (value) =>
                  value && (
                    <StatusHighliter
                      className={
                        value === 'Approved'
                          ? 'green'
                          : value === 'Rejected'
                            ? 'red'
                            : 'yellow'
                      }
                    >
                      {value}
                    </StatusHighliter>
                  ),
              },
              {
                title: 'Transactions Date',
                dataSelector: 'transactionsDate',
                dataType: 'date',
                CellRenderer: (value) => (value ? value : 'N/A'),
              },
              {
                title: 'Requested On',
                dataSelector: 'createdOn',
                dataType: 'date',
                CellRenderer: (value) => (value ? value : 'N/A'),
              },
              {
                title: 'Processed On',
                dataSelector: 'approvalDate',
                dataType: 'date',
                CellRenderer: (value) => (value ? value : 'N/A'),
              },
              {
                title: 'Requestor Remark',
                dataSelector: 'fromAccountsRemark',
                dataType: 'string',
                CellRenderer: (value) => (value ? value : 'N/A'),
              },
              {
                title: 'My Remark',
                dataSelector: 'toAccountsRemark',
                dataType: 'string',
                CellRenderer: (value) => (value ? value : 'N/A'),
              },
            ]}
            tableData={walletDepositRequests}
          />
          <Pagination
            totalRecords={totalRecords}
            paginationData={paginationData}
            setPaginationData={setPaginationData}
          />
          <Modal
            modalStatus={showModal}
            setModalStatus={() => {
              resetResponseData();
              resetForm();
              setModalType('');
              setShowModal(false);
              setLogs([]);
            }}
            hideCloseButton
          >
            {modalType === 'Logs' ? (
              <StyledModalContainer width={`1200px`}>
                <h3>API Logs</h3>
                <StyledApiCallLogsContainer>
                  <LoadingSpinner
                    isLoading={
                      responseStatus === '' && logs?.length === 0 && isLoading
                    }
                  />
                  <NoData
                    status={
                      responseStatus !== API_RESPONSE_TYPES.FAILURE &&
                      !isLoading &&
                      logs?.length === 0
                    }
                    message={`No api logs found`}
                  />
                  <MessageBox
                    status={responseStatus}
                    message={responseMessage}
                  />
                  {logs?.length > 0 &&
                    logs.map(
                      (
                        {
                          requestOn: createdOn,
                          type: processType,
                          request,
                          requestBody,
                          response,
                          responseOn: responseTime,
                        },
                        index
                      ) => (
                        <Accordination
                          key={index}
                          header={`${processType}`}
                          autoExpanded={true}
                        >
                          <Grid columns={'calc(50% - 10px) calc(50% - 10px)'}>
                            <GridItem>
                              <StyledBodyContainer>
                                <StyledHeading>
                                  API Request {createdOn && `( ${createdOn} )`}
                                </StyledHeading>
                                <StyledContent>{request}</StyledContent>
                              </StyledBodyContainer>
                              {requestBody && (
                                <StyledBodyContainer>
                                  <StyledHeading>
                                    API Request Body
                                  </StyledHeading>
                                  <StyledContent>{requestBody}</StyledContent>
                                </StyledBodyContainer>
                              )}
                            </GridItem>
                            <GridItem>
                              <StyledBodyContainer>
                                <StyledHeading>
                                  API Response{' '}
                                  {responseTime && `( ${responseTime} )`}
                                </StyledHeading>
                                <StyledContent>
                                  <JSONPretty
                                    id="json-pretty"
                                    data={response}
                                  ></JSONPretty>
                                </StyledContent>
                              </StyledBodyContainer>
                            </GridItem>
                          </Grid>
                        </Accordination>
                      )
                    )}
                </StyledApiCallLogsContainer>
              </StyledModalContainer>
            ) : (
              <StyledModalContainer width="500px">
                <h3>
                  {modalType === 'Approve'
                    ? 'Approve Request'
                    : 'Reject Request'}
                </h3>
                <FormContainer>
                  <Form method="POST" action="#" onSubmit={onSubmit}>
                    <Fieldset>
                      <Label required={modalType === 'Reject'}>Remark</Label>
                      <TextInput
                        value={remark}
                        onChange={setRemark}
                        placeholder="Please enter remark"
                        disabled={isLoading === true}
                      />
                    </Fieldset>
                    {showModal && responseStatus !== '' && (
                      <Fieldset>
                        <MessageBox
                          status={responseStatus}
                          message={responseMessage}
                        />
                      </Fieldset>
                    )}
                    <Fieldset>
                      <CreateButton
                        disabled={isLoading === true}
                        type="submit"
                        style={{ width: 'auto' }}
                      >
                        {modalType === 'Approve' ? `Approve` : `Reject`}
                      </CreateButton>
                      <ResetButton
                        disabled={isLoading === true}
                        type="button"
                        onClick={resetForm}
                      >
                        Reset
                      </ResetButton>
                    </Fieldset>
                    <OverlayLoader showLoader={showModal && isLoading} />
                  </Form>
                </FormContainer>
              </StyledModalContainer>
            )}
          </Modal>
        </>
      )}
    </>
  );
};

export default withAppHOC(FundRequestsTable);
